module.exports = __webpack_public_path__ + "media/icons/szkody-pojazdu-orange@x2-f04845ee.png";